/// <reference path="../providers/validation.service.ts" />
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../auth/authentication.service';
import { AuthService } from '../auth/auth.service';
import { environment } from '../../../environments/environment';
import { Actions, Modules, UserRole } from '../../shared/enum/enum';
import { PermissionService } from '../../shared/providers/permission.service';

//import { debug } from 'util';

@Injectable()
export class AuthGuard implements CanActivate {

  private user: any;
  private hasAccess = true;

  constructor(private authService: AuthenticationService, private router: Router, private auth0: AuthService, private permissionService: PermissionService) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (state.url.indexOf('shared/groups') > -1) {
      this.authService.onRegisterRedirection = "shared/groups";
    }
    else {
      this.authService.onRegisterRedirection = "";
    }
    if (this.authService.isAuth0Enabled) {
      localStorage.setItem('redirectUrl', state.url);
      var date: any = new Date().getTime();
      var time: any = localStorage.getItem('tokenRefreshTime');
      var status: any = localStorage.getItem('isTokenExpired');
      var timediff = (date - new Date(time).getTime()) / 1000;
      var timediff = timediff / 60;

      if (timediff > environment.auth0.tokenRefreshTime) {
        // this.auth0.checkAuthentication();      
      }

      //if (status == 'false') {
      //    this.auth0.login();
      //}         
    }

    this.user = this.authService.user;
    this.authService.redirectUrl = state.url; // For 1031 access
    if (this.user) {
      try {
        const roles = next.data.roles;
        if (roles != null && roles.length > 0) {
          for (let role of roles) {
            if (this.user.RoleIdList.indexOf(role) < 0) {
              this.hasAccess = false;
            }
            else {
              this.hasAccess = true;
              break;
            }
          };
        }

        if (
          this.user.RoleIdList.includes(UserRole.Admin) ||
          this.user.RoleIdList.includes(UserRole.DataEntryStaff) ||
          this.user.RoleIdList.includes(UserRole.SuperAdmin) ||
          this.user.RoleIdList.includes(UserRole.Broker)
        ) {
          const moduleId = next.data['moduleId'];
          const actionId = next.data['actionId'];
          if (moduleId != null && moduleId != undefined && actionId != null && actionId != undefined) {
            const prevRoute = next.queryParamMap.get('prevroute');
            let hasPermission = false;
            if (prevRoute != null && prevRoute != undefined && prevRoute === 'Buyer Criteria' && moduleId == Modules.ExternalUsers && actionId == Actions.Details) {
              hasPermission = this.permissionService.hasPermission(
                Modules.BuyerCriteria,
                Actions.Details
              );
            }
            else {
              hasPermission =
                this.permissionService.hasPermission(
                  moduleId,
                  actionId,
                  []
                );
            }
            if (hasPermission) {
              this.hasAccess = true;
            }
            else {
              this.hasAccess = false;
            }
          }

        }
      }
      catch (ex) {
        this.authService.logOutUserOnError(ex);
      }

      if (!this.hasAccess) {
        this.router.navigate(['/']);
        return false;
      }

      this.authService.loggedIn.next(true);
      return true;
    }
    else {
      this.router.navigate(['/home'], { queryParams: { redirect: true } });
      return false;
    }
  }

}
